import { FieldType, FieldTypes } from '@src/app/shared/field';

// ContactTypes
// 1 - Телефон
// 2 - Email
// 3 - Веб-страница
// 4 - Ссылка на документ
// 5 - Социальная сеть
// 6 - Мессенджер
// 7 - Прочее
// 8 - Файл
// 9 - Прочее (только для администраторов объединения)
// 10 - Прочее (для администраторов и участника)
// 11 - Ссылка на документ (только для администраторов объединения)
// 12 - Ссылка на документ (для администраторов и участника)
// 13 - Файл (только для администраторов объединения)
// 14 - Файл (для администраторов и участника)
// 15 - Список
// 16 - Список (только для администраторов объединения)
// 17 - Список (для администраторов и участника)

/**
 * Утилита, которая проверяет, что контакт не является ни Прочим, ни файлом, ни списком
 * @param typeId тип контакта
 */
export const isNotOtherAndNotFileAndNotListContact = (typeId?: number): boolean => {
  return (
    !!typeId &&
    ![
      FieldTypes.Text,
      FieldTypes.TextForAdmin,
      FieldTypes.TextForAdminAndUser,
      FieldTypes.File,
      FieldTypes.FileForAdmin,
      FieldTypes.FileForAdminAndUser,
      FieldTypes.List,
      FieldTypes.ListForAdmin,
      FieldTypes.ListForAdminAndUser,
    ].includes(typeId)
  );
};

/**
 * Утилита, которая проверяет является ли контакт Прочим
 * @param typeId тип контакта
 */
export const isOtherContact = (typeId?: number): boolean => {
  return !!typeId && [FieldTypes.Text, FieldTypes.TextForAdmin, FieldTypes.TextForAdminAndUser].includes(typeId);
};

/**
 * Утилита, которая проверяет является ли контакт файлом
 * @param typeId тип контакта
 */
export const isFileContact = (typeId?: number): boolean => {
  return !!typeId && [FieldTypes.File, FieldTypes.FileForAdmin, FieldTypes.FileForAdminAndUser].includes(typeId);
};

/**
 * Утилита, которая проверяет является ли контакт списком
 * @param typeId тип контакта
 */
export const isListContact = (typeId?: number): boolean => {
  return !!typeId && [FieldTypes.List, FieldTypes.ListForAdmin, FieldTypes.ListForAdminAndUser].includes(typeId);
};

/**
 * Утилита, которая удаляет типы контактов, если у пользователя нет permissions для типа контакта
 * @param contactTypes типы контакта
 * @param userPermissions разрешения пользователя
 */
export const removeContactsByUserPermissions = (contactTypes: FieldType[], userPermissions?: string[]): FieldType[] => {
  return contactTypes.filter(
    contactType =>
      !contactType.permissions ||
      !!contactType.permissions.filter(contactTypePermission => (userPermissions || []).includes(contactTypePermission))
        .length,
  );
};
